import React, { useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context';
import './AccountOverview.css';

const AccountOverview = () => {
  const { user, logout, getAddresses } = useAuth();
  const navigate = useNavigate();

  const addressCount = useMemo(() => (getAddresses ? getAddresses().length : 0), [getAddresses]);

  const initials = useMemo(() => {
    const name = (user?.name && user.name.trim()) || '';
    if (name) {
      const parts = name.split(/\s+/).filter(Boolean);
      const first = parts[0]?.[0] || '';
      const last = parts[parts.length - 1]?.[0] || '';
      return (first + last).toUpperCase();
    }
    const email = user?.email || '';
    return email ? email[0].toUpperCase() : '?';
  }, [user?.name, user?.email]);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="account-overview">
      <header className="account-overview__header">
        <h1 className="account-overview__title">My Account</h1>
        <div
          className="signed-in-banner"
          aria-label={`Signed in as ${user?.name || user?.email || ''}${user?.name && user?.email ? ` (${user.email})` : ''}`}
        >
          {user?.image_url ? (
            <img src={user.image_url} alt="" className="sib-avatar" />
          ) : (
            <div className="sib-avatar" aria-hidden="true">{initials}</div>
          )}
          <div className="sib-text">
            <span className="sib-label">Signed in as</span>
            <span className="sib-name">{user?.name || user?.email}</span>
            {user?.name && user?.email && <span className="sib-email">({user.email})</span>}
          </div>
        </div>
      </header>

      <section className="account-overview__grid">
        <Link to="/account/profile" className="account-card">
          <div className="account-card__title">Profile</div>
          <div className="account-card__desc">View and edit your profile details</div>
        </Link>

        <Link to="/account/orders" className="account-card">
          <div className="account-card__title">Orders</div>
          <div className="account-card__desc">See your order history and status</div>
        </Link>

        <Link to="/account/address" className="account-card">
          <div className="account-card__title">Address Book</div>
          <div className="account-card__desc">
            Manage shipping addresses {addressCount > 0 ? `(${addressCount})` : ''}
          </div>
        </Link>

        <button
          className="account-card account-card--button"
          onClick={() => window.dispatchEvent(new CustomEvent('openChat'))}
        >
          <div className="account-card__title">Chat with Support</div>
          <div className="account-card__desc">Talk to our customer service team</div>
        </button>

        <button className="account-card account-card--button" onClick={handleLogout}>
          <div className="account-card__title">Log out</div>
          <div className="account-card__desc">Sign out of your account</div>
        </button>
      </section>

      <div className="account-overview__footer">
        <Link to="/shop" className="btn btn-link">Back to Shop</Link>
      </div>
    </div>
  );
};

export default AccountOverview;
